interface CurrencyMap {
  [key: string]: string
}

const currencyObj: CurrencyMap = {
  // 主要货币
  USD: 'us', // 美元
  USC: 'us', // 美分
  EUR: 'eu', // 欧元
  GBP: 'gb', // 英镑
  JPY: 'jp', // 日元
  CNY: 'cn', // 人民币
  HKD: 'hk', // 港币
  TWD: 'tw', // 新台币
  KRW: 'kr', // 韩元
  SGD: 'sg', // 新加坡元
  AUD: 'au', // 澳元
  CAD: 'ca', // 加元
  CHF: 'ch', // 瑞士法郎
  NZD: 'nz', // 新西兰元
  // 亚洲货币
  INR: 'in', // 印度卢比
  MYR: 'my', // 马来西亚林吉特
  THB: 'th', // 泰铢
  IDR: 'id', // 印尼盾
  PHP: 'ph', // 菲律宾比索
  VND: 'vn', // 越南盾
  PKR: 'pk', // 巴基斯坦卢比
  BDT: 'bd', // 孟加拉塔卡
  LKR: 'lk', // 斯里兰卡卢比
  NPR: 'np', // 尼泊尔卢比
  MMK: 'mm', // 缅甸元
  KHR: 'kh', // 柬埔寨瑞尔
  LAK: 'la', // 老挝基普
  MNT: 'mn', // 蒙古图格里克
  BND: 'bn', // 文莱元
  CNH: 'cn', // 港币

  // 欧洲货币
  SEK: 'se', // 瑞典克朗
  NOK: 'no', // 挪威克朗
  DKK: 'dk', // 丹麦克朗
  PLN: 'pl', // 波兰兹罗提
  CZK: 'cz', // 捷克克朗
  HUF: 'hu', // 匈牙利福林
  RON: 'ro', // 罗马尼亚列伊
  BGN: 'bg', // 保加利亚列弗
  RUB: 'ru', // 俄罗斯卢布
  UAH: 'ua', // 乌克兰格里夫纳
  BYN: 'by', // 白俄罗斯卢布
  MDL: 'md', // 摩尔多瓦列伊
  RSD: 'rs', // 塞尔维亚第纳尔
  HRK: 'hr', // 克罗地亚库纳
  BAM: 'ba', // 波斯尼亚和黑塞哥维那可兑换马克
  ALL: 'al', // 阿尔巴尼亚列克
  MKD: 'mk', // 北马其顿第纳尔

  // 中东货币
  AED: 'ae', // 阿联酋迪拉姆
  SAR: 'sa', // 沙特里亚尔
  ILS: 'il', // 以色列新谢克尔
  TRY: 'tr', // 土耳其里拉
  QAR: 'qa', // 卡塔尔里亚尔
  KWD: 'kw', // 科威特第纳尔
  UZS: 'uz', // 乌兹别克斯坦索姆
  KZT: 'kz', // 哈萨克斯坦坚戈
  GEL: 'ge', // 格鲁吉亚拉里
  AZN: 'az', // 阿塞拜疆马纳特
  AMD: 'am', // 亚美尼亚德拉姆

  // 美洲货币
  MXN: 'mx', // 墨西哥比索
  BRL: 'br', // 巴西雷亚尔
  ARS: 'ar', // 阿根廷比索
  CLP: 'cl', // 智利比索
  COP: 'co', // 哥伦比亚比索
  PEN: 'pe', // 秘鲁索尔
  XCD: 'gd', // 东加勒比元
  BBD: 'bb', // 巴巴多斯元
  JMD: 'jm', // 牙买加元
  TTD: 'tt', // 特立尼达和多巴哥元
  BZD: 'bz', // 伯利兹元
  GTQ: 'gt', // 危地马拉格查尔
  HNL: 'hn', // 洪都拉斯伦皮拉
  NIO: 'ni', // 尼加拉瓜科多巴
  CRC: 'cr', // 哥斯达黎加科朗
  PAB: 'pa', // 巴拿马巴波亚
  DOP: 'do', // 多米尼加比索
  HTG: 'ht', // 海地古德
  BSD: 'bs', // 巴哈马元
  KYD: 'ky', // 开曼群岛元
  BMD: 'bm', // 百慕大元

  // 非洲货币
  ZAR: 'za', // 南非兰特
  EGP: 'eg', // 埃及镑
  NGN: 'ng', // 尼日利亚奈拉
  KES: 'ke', // 肯尼亚先令
  MUR: 'mu', // 毛里求斯卢比
  MAD: 'ma', // 摩洛哥迪拉姆
  TND: 'tn', // 突尼斯第纳尔
  DZD: 'dz', // 阿尔及利亚第纳尔
  XOF: 'sn', // 西非法郎
  XAF: 'cm', // 中非法郎
  CDF: 'cd', // 刚果法郎
  RWF: 'rw', // 卢旺达法郎
  UGX: 'ug', // 乌干达先令
  TZS: 'tz', // 坦桑尼亚先令
  ETB: 'et', // 埃塞俄比亚比尔
  SDG: 'sd', // 苏丹镑
  LYD: 'ly', // 利比亚第纳尔
  MRO: 'mr', // 毛里塔尼亚乌吉亚
  GNF: 'gn', // 几内亚法郎

  // 大洋洲货币
  FJD: 'fj', // 斐济元
  WST: 'ws', // 萨摩亚塔拉
  TOP: 'to', // 汤加潘加
  SBD: 'sb', // 所罗门群岛元
  VUV: 'vu', // 瓦努阿图瓦图
  PGK: 'pg', // 巴布亚新几内亚基那
  XPF: 'pf', // 太平洋法郎

  // 数字货币
  USDT: 'usdt', // 泰达币
  USDC: 'usdc', // 美元稳定币
  BUSD: 'busd', // 美元稳定币
}

export default currencyObj
